import { useTranslation } from 'react-i18next';
import { Text, Button, tokens } from '@hotjar/hotsauce';
import { useGtmOAuthUrl } from '../../hooks/useGtmOAuthUrl';
import { useGTMIntegrationTracking } from '../IntegrateWithGTM/hooks/useGTMIntegrationTracking';
import { HeroWrapper, HeroCopyWrapper, InstallationIcon } from './styles';

interface GTMInstallationHeroProps {
  onOtherPlatformsClick: () => void;
}

export const GTMInstallationHero = ({
  onOtherPlatformsClick,
}: GTMInstallationHeroProps): JSX.Element | null => {
  const { t } = useTranslation();
  const gtmOAuthURL = useGtmOAuthUrl();
  const { trackIntegrationStep } = useGTMIntegrationTracking();
  const handleStartClick = () => {
    trackIntegrationStep('Authenticate');
    window.location.assign(gtmOAuthURL);
  };

  if (!gtmOAuthURL) {
    return null;
  }

  return (
    <HeroWrapper data-testid="hero-section">
      <InstallationIcon icon="google_tag_manager" size="l" />
      <HeroCopyWrapper>
        <Text
          css={{ marginBottom: tokens.spacer.x1 }}
          textType="header4"
          textColor="text_default"
          as="h2"
        >
          {t('activation:setup-wizard.main-page.hero.title-gtm')}
        </Text>
        <Text
          css={{ marginBottom: tokens.spacer.x2 }}
          textType="body2"
          textColor="text_default"
          as="p"
        >
          {t('activation:setup-wizard.main-page.hero.description-gtm')}
        </Text>
        <div>
          {gtmOAuthURL ? (
            <Button
              css={{ marginRight: tokens.spacer.x2 }}
              as="a"
              href={gtmOAuthURL}
              onClick={handleStartClick}
              size="l"
            >
              {t('activation:setup-wizard.main-page.hero.start-setup')}
            </Button>
          ) : null}
          <Button kind="secondary" onClick={onOtherPlatformsClick} size="l">
            {t('activation:setup-wizard.main-page.hero.use-other')}
          </Button>
        </div>
      </HeroCopyWrapper>
    </HeroWrapper>
  );
};
